var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32L156 188v334.4c0 148.8 75.2 287.2 199.2 368L512 992l156-101.6c124.8-80.8 199.2-219.2 199.2-368V188L512 32z",
    fill: "#D6AB7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388.8 839.2c-108-70.4-172-188.8-172-316.8V228L512 98.4l295.2 129.6v295.2c0 128.8-64 247.2-172 316.8L512 920l-123.2-80.8z",
    fill: "#82CFCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 32L156 188v334.4c0 148.8 75.2 287.2 199.2 368L512 992V32z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 1000c-1.6 0-3.2-0.8-4-1.6L352 896.8c-128-82.4-204-222.4-204-374.4V188c0-3.2 1.6-6.4 4.8-7.2L508.8 24.8c2.4-0.8 4-0.8 6.4 0l356 156c3.2 1.6 4.8 4 4.8 7.2v334.4c0 152-76 292-203.2 374.4l-156 101.6c-1.6 0.8-3.2 1.6-4.8 1.6zM164 193.6v329.6c0 146.4 73.6 281.6 196 360.8l152 98.4 152-98.4c122.4-80 196-215.2 196-360.8V193.6L512 40.8 164 193.6z",
    fill: "#6A576D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 927.2c-1.6 0-3.2-0.8-4-1.6l-123.2-80c-109.6-71.2-175.2-192.8-175.2-324V228c0-3.2 1.6-6.4 4.8-7.2l295.2-129.6c2.4-0.8 4-0.8 6.4 0l295.2 129.6c3.2 1.6 4.8 4 4.8 7.2v295.2c0 131.2-65.6 252-175.2 324l-123.2 80H512zM224.8 232.8v289.6c0 125.6 63.2 241.6 168 310.4l118.4 76.8 118.4-76.8c105.6-68.8 168-184.8 168-310.4V232.8L512 107.2 224.8 232.8z",
    fill: "#6A576D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 599.2c-10.4 0-20-4.8-26.4-12.8L386.4 462.4l53.6-42.4 72 90.4 124-156.8 53.6 42.4-150.4 190.4c-7.2 8-16.8 12.8-27.2 12.8z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 607.2c-12.8 0-24.8-5.6-32.8-16L380 467.2c-1.6-1.6-1.6-4-1.6-5.6 0-2.4 1.6-4 3.2-5.6l53.6-42.4c3.2-2.4 8.8-2.4 11.2 1.6L512 497.6l118.4-148.8c2.4-3.2 8-4 11.2-1.6l53.6 42.4c3.2 2.4 4 8 1.6 11.2l-152 190.4c-8 10.4-20 16-32.8 16z m-114.4-144l94.4 118.4c4.8 6.4 12.8 9.6 20 9.6v8-8c8 0 15.2-4 20.8-9.6l145.6-184-40.8-32.8-119.2 150.4c-1.6 1.6-4 3.2-6.4 3.2-2.4 0-4.8-0.8-6.4-3.2l-67.2-84.8-40.8 32.8z",
    fill: "#6A576D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.9a45ceb5c8608761e34993d609eee345.svg";
export { ForwardRef as ReactComponent };